import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
  Drawer,
  Typography,
  Divider,
  Container,
  IconButton,
  List,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAtom, useAtomValue } from 'jotai';
import useAPI from '../../api';
import { notificationDrawerOpenAtom } from '../../Atoms';
import NotificationBox from './NotificationBox';
import { notifySMSReceivedAtom } from '../../Atoms/HubAtoms';

const useStyles = makeStyles({
  title: {
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '16px',
    paddingBottom: '16px',
  },
});

const Notification = function Notification(
  n,
  handleGoToCustomerPage,
  handleReadNotification
) {
  const {
    id,
    entityId,
    createdOn,
    sender,
    baseEntityFullName,
    baseEntityType,
    content,
  } = n;
  const intl = useIntl();

  return (
    <NotificationBox
      key={id}
      title={
        baseEntityType === 'Branch'
          ? intl.messages.MARK_MESSAGE_AS_READ
          : intl.messages.GOTO_CUSTOMER_PAGE
      }
      entityId={baseEntityType === 'Branch' ? id : entityId}
      createdOn={createdOn}
      baseEntityFullName={baseEntityFullName}
      sender={sender}
      content={content}
      onClick={
        baseEntityType === 'Branch'
          ? handleReadNotification
          : handleGoToCustomerPage
      }
    />
  );
};

const NotificationDrawer = function NotificationDrawer({
  setNewItems,
  removeClickedItem,
  onClick,
  setUnreadMessagesCounter,
  ObserverWrapper = null,
  recordCount = 0,
  unreadMessagesCounter = 0,
}) {
  const classes = useStyles();
  const intl = useIntl();
  const API = useAPI();
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useAtom(
    notificationDrawerOpenAtom
  );
  const notifySMSReceived = useAtomValue(notifySMSReceivedAtom);

  useEffect(() => {
    //add the notification when notifySMSReceived change
    if (notifySMSReceived?.id) {
      setNewItems(notifySMSReceived, recordCount + 1);
    }
  }, [notifySMSReceived?.id]);

  const handleGoToCustomerPage = (customerId, baseEntityFullName) => {
    //when the message sender is a customer
    setNotificationDrawerOpen(false);
    if (onClick) onClick(customerId, baseEntityFullName);
  };

  const handleReadNotification = (notificationId) => {
    //when the message sender isn't a customer
    API.setMessageRead(
      notificationId,
      () => {
        removeClickedItem(notificationId, recordCount - 1);
        setUnreadMessagesCounter(unreadMessagesCounter - 1);
      },
      (err) => {
         
        console.log(err);
      }
    );
  };

  return (
    <Drawer
      anchor="right"
      open={notificationDrawerOpen}
      onClose={() => setNotificationDrawerOpen(false)}
      sx={{
        '& .MuiPaper-root': {
          overflow: 'hidden',
          width: '324px',
          borderRadius: '18px 0px 0px 18px',
        },
      }}
    >
      <Container className={classes.title} style={{ display: 'flex' }}>
        <Typography variant="h6">{intl.messages.NOTIFICATIONS}</Typography>
        <IconButton onClick={() => setNotificationDrawerOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Container>
      <Divider />
      <List
        dense
        sx={{ overflowY: 'auto', overflowX: 'hidden', height: 'inherit' }}
      >
        <ObserverWrapper
          Component={(n) =>
            Notification(n, handleGoToCustomerPage, handleReadNotification)
          }
        />
      </List>
    </Drawer>
  );
};

NotificationDrawer.propTypes = {
  ObserverWrapper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  setNewItems: PropTypes.func.isRequired,
  removeClickedItem: PropTypes.func.isRequired,
  recordCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  setUnreadMessagesCounter: PropTypes.func.isRequired,
  unreadMessagesCounter: PropTypes.number,
};

export default NotificationDrawer;
